import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hasGlobalFeature } from 'selectors';
import Modal from './AskTheExpertModal';

/*::
type i18nProps = {
  form: {
    action: string,
    heading: string,
    placeholder: string,
    close: string,
    cancel: string,
  },
  successMessage: {
    heading: string,
    body: string,
    close: string,
  }
}
*/

class AskTheExpertToggle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal() {
    this.setState(state => ({ showModal: !state.showModal }));
  }

  render() {
    const { expert, features, children, i18n } = this.props;
    return (
      features.askTheExpert &&
      expert && [
        <span key="askTheExpert">
          {children({ toggleModal: this.toggleModal })}
        </span>,
        this.state.showModal && (
          <Modal
            expert={expert}
            onClose={this.toggleModal}
            key="askTheExpertModal"
            i18n={i18n /*: i18nProps */}
          />
        ),
      ]
    );
  }
}

const mapStateToProps = state => ({
  expert: state.meta.askTheExpert.expert,
  features: {
    askTheExpert: hasGlobalFeature(state, 'ask_the_expert'),
  },
});

export default connect(mapStateToProps)(AskTheExpertToggle);
